export default __webpack_public_path__ + "static/media/homeWorkAssist.597e064b.svg";